import React from 'react';

import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button';

import type { AlignmentButtonProps } from './titleareaContentComponentsTypes';

export const AlignmentButton = ({
	setIsMoreOptionsButtonFocused,
	floatingToolbarButtonStyle,
	userOffline,
	handleClick,
	isSelected,
	icon,
	isDisabled,
	testId,
}: AlignmentButtonProps) => (
	<Button
		appearance="subtle"
		style={{
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			...floatingToolbarButtonStyle,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			...(userOffline && {
				backgroundColor: token('color.background.disabled'),
			}),
		}}
		onClick={handleClick}
		onFocus={() => setIsMoreOptionsButtonFocused(true)}
		onBlur={() => setIsMoreOptionsButtonFocused(false)}
		isSelected={isSelected}
		iconBefore={icon}
		isDisabled={userOffline || isDisabled}
		testId={testId}
	/>
);
